import { ImagePresets } from "@pages/Article/components/ArticleThumbnail/utils/enums";
import { CaaSImageFilters } from "@typings/OptimisedImage";

export const DEFAULT_CAAS_FILTER: CaaSImageFilters = {
  w: ImagePresets.LARGE,
  dpr: 1,
  f: "webp",
};
